export const STATUS_OPTIONS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];
